import { STORAGE_KEY } from "./state";
import { STORAGE_KEY_ACHIEVEMENTS } from "./modules/achievements/state";
import { STORAGE_KEY_CHARACTERS } from "./modules/characters/state";
import { STORAGE_KEY_PAGES } from "./modules/pages/state";
import { STORAGE_KEY_ITEMS } from "./modules/items/state";
import { STORAGE_KEY_RULES } from "./modules/rules/state";
import { STORAGE_KEY_SPELLS } from "./modules/spells/state";

const localStoragePlugin = store => {
  store.subscribe((mutation, { session }) => {
    if (
      ["LOGIN", "LOGOUT", "SET_USER", "REDIRECT_SET"].indexOf(mutation.type) >
      -1
    ) {
      // console.log(mutation.type);
      if (session)
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    }
  });

  // achievements
  store.subscribe((mutation, { achievements }) => {
    if (
      [
        "achievements/SET_ALL",
        "achievements/SET_ITEM",
        "achievements/CREATE",
        "achievements/UPDATE",
        "achievements/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (achievements)
        window.localStorage.setItem(
          STORAGE_KEY_ACHIEVEMENTS,
          JSON.stringify(achievements)
        );
    }
  });

  // characters
  store.subscribe((mutation, { characters }) => {
    if (
      [
        "characters/SET_ALL",
        "characters/SET_ITEM",
        "characters/CREATE",
        "characters/UPDATE",
        "characters/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (characters)
        window.localStorage.setItem(
          STORAGE_KEY_CHARACTERS,
          JSON.stringify(characters)
        );
    }
  });

  // pages
  store.subscribe((mutation, { pages }) => {
    if (
      [
        "pages/SET_ALL",
        "pages/SET_ITEM",
        "pages/CREATE",
        "pages/UPDATE",
        "pages/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (pages)
        window.localStorage.setItem(STORAGE_KEY_PAGES, JSON.stringify(pages));
    }
  });

  // items
  store.subscribe((mutation, { items }) => {
    if (
      [
        "items/SET_ALL",
        "items/SET_ITEM",
        "items/CREATE",
        "items/UPDATE",
        "items/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (items)
        window.localStorage.setItem(STORAGE_KEY_ITEMS, JSON.stringify(items));
    }
  });

  // rules
  store.subscribe((mutation, { rules }) => {
    if (
      [
        "rules/SET_ALL",
        "rules/SET_ITEM",
        "rules/CREATE",
        "rules/UPDATE",
        "rules/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (rules)
        window.localStorage.setItem(STORAGE_KEY_RULES, JSON.stringify(rules));
    }
  });

  // spells
  store.subscribe((mutation, { spells }) => {
    if (
      [
        "spells/SET_ALL",
        "spells/SET_ITEM",
        "spells/CREATE",
        "spells/UPDATE",
        "spells/DELETE"
      ].indexOf(mutation.type) > -1
    ) {
      // console.log(mutation.type)
      if (spells)
        window.localStorage.setItem(STORAGE_KEY_SPELLS, JSON.stringify(spells));
    }
  });
};

export default localStoragePlugin;
